import { useState, useEffect } from 'react';
import useLabelingStore from '../store/useDetectionStore';
// Custom hook for managing AddClassPopup logic
const useAddClassPopup = ({ classInfo, isModalOpen, handleCloseModal, handleSaveClass }) => {
  const [className, setClassName] = useState('');
  const [color, setColor] = useState('#ff0000');
  const [aiAliases, setAiAliases] = useState('');
  const [showColorPicker, setShowColorPicker] = useState(false);

  // Reset or load class info when modal opens or classInfo changes
  useEffect(() => {
    if (isModalOpen) {
      setClassName(classInfo?.name || '');
      setColor(classInfo?.color || '#ff0000');
      setAiAliases(classInfo?.aiAliases || '');
    }
  }, [classInfo, isModalOpen]);

  // Toggle color picker visibility
  const handleColorClick = () => {
    setShowColorPicker(prev => !prev);
  };

  // Update color state
  const handleColorChange = (newColor) => {
    setColor(newColor.hex);
  };

  // Save class data and handle modal state
  const handleSave = () => {
    const payload = {
      id: classInfo?.id ?? null,
      name: className,
      color,
      // Optional natural-language terms the open-vocab detector should look for
      // to fill this class (e.g. "person, man, worker"). Empty = use the name.
      aiAliases: aiAliases.trim(),
    };
    handleSaveClass(payload);

    // Reset form if adding a new class
    if (!classInfo) {
      setClassName('');
      setColor('#ff0000');
      setAiAliases('');
      setShowColorPicker(false);
    }

    handleCloseModal();
  };

  return {
    className,
    setClassName,
    color,
    aiAliases,
    setAiAliases,
    showColorPicker,
    handleColorClick,
    handleColorChange,
    handleSave
  };
};

export default useAddClassPopup;